import { SET_REQUEST_DELIVERY_METHOD, UPDATE_REQUEST_PAYMENT_FORM } from 'apps/auth/actions/requestAction';
import update from 'apps/auth/helpers/Immutability';

const request = (state = {}, action) => {
    let mergeState;
    switch (action.type) {
        case SET_REQUEST_DELIVERY_METHOD:
            if (state?.requestForm?.paymentSourceFromMethod) {
                mergeState = update(state, {
                    requestForm: {
                        paymentSourceFromMethod: { $set: action.method },
                    },
                });
                break;
            }
        case UPDATE_REQUEST_PAYMENT_FORM:
            if (state?.requestForm) {
                mergeState = update(state, {
                    requestForm: { $merge: action.requestForm },
                });
                break;
            }
        default:
            return state;
    }
    return mergeState;
};
export default request;
